'use client';

import config from '@haaretz/l-config';
import fork from '@haaretz/l-fork.macro';
import mq from '@haaretz/l-mq.macro';
import space from '@haaretz/l-space.macro';
import HtzImage from '@haaretz/s-htz-image';
import s9 from 'style9';

import type { ImageFragment } from '@haaretz/s-fragments/HTZ_image_Image';
import type { HtzImageProps } from '@haaretz/s-htz-image';
const c = s9.create({
  astronautImgError: {
    width: space(33),
    marginTop: space(-36),
    marginBottom: space(4),

    ...mq({
      from: 'l',
      value: {
        width: space(37),
      },
    }),
  },
  astronautImgSuccess: {
    width: space(47.5),
    marginTop: space(-40),
    marginBottom: space(3),

    ...mq({
      from: 'l',
      value: {
        marginBottom: space(5),
        width: space(51),
      },
    }),
  },
});

const env = config.get('env');

export function AstronautImageError() {
  const imgData: ImageFragment['files'][number] = {
    __typename: 'ImageViewModel_ImageFile',
    crops: { __typename: 'ImageCrops' },
    width: 146,
    height: 120,
    path:
      env === 'prod'
        ? fork({
            default: '71/c2/fa6803704f75903458e2ed2c986c/error-dsk.png',
          })
        : fork({
            default: 'aa/1c/08363a7b45198f5f99cd7583a159/error-dsk.png',
          }),
  };

  const contentId =
    env === 'prod'
      ? fork({
          default: '00000193-6cb9-d62c-a1db-7fbb4d320001',
        })
      : fork({
          default: '00000193-6d18-d057-a3bb-fd5f53010001',
        });

  const imgProps: HtzImageProps = {
    imgData,
    type: 'image',
    alt: 'alt',
    contentId,
    widths: [146, 133],
    sizes: [{ size: '146px' }],
    aspect: 'full',
  };

  return <HtzImage {...imgProps} styleExtend={[c.astronautImgError]} />;
}

export function AstronautImageSuccess() {
  const imgData: ImageFragment['files'][number] = {
    __typename: 'ImageViewModel_ImageFile',
    crops: { __typename: 'ImageCrops' },
    width: 203,
    height: 161,
    path:
      env === 'prod'
        ? fork({
            default: '5e/15/cde451bf47e283b226ded3902442/success-dsk.png',
          })
        : fork({
            default: '6c/35/0a5fd5e144b99cb0d5b108775632/success-dsk.png',
          }),
  };

  const contentId =
    env === 'prod'
      ? fork({
          default: '00000193-6cb7-da6e-afdb-7ef7f8280001',
        })
      : fork({
          default: '00000193-6cf2-d1f5-a1df-6dfadbd20001',
        });

  const imgProps: HtzImageProps = {
    imgData,
    type: 'image',
    alt: 'alt',
    contentId,
    widths: [190, 204],
    sizes: [{ size: '190px' }],
    aspect: 'full',
  };

  return <HtzImage {...imgProps} styleExtend={[c.astronautImgSuccess]} />;
}
